import { CheckCircle2, ArrowRight } from "lucide-react";
import { POND_SERVICES, GARDEN_SERVICES } from "@/lib/siteData";

const ServiceColumn = ({ group }) => {
  const Icon = group.icon;
  return (
    <article
      data-testid={`service-group-${group.id}`}
      className="service-card group flex flex-col rounded-3xl border border-green-100 bg-white overflow-hidden shadow-sm"
    >
      <div className="relative aspect-[16/9] overflow-hidden">
        <img
          src={group.image}
          alt={group.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-green-950/70 via-green-950/10 to-transparent" />
        <div className="absolute bottom-4 left-5 flex items-center gap-3 text-white">
          <span className="w-11 h-11 rounded-xl bg-green-600 flex items-center justify-center shadow-lg">
            <Icon className="w-5 h-5" />
          </span>
          <h3 className="text-xl sm:text-2xl font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>
            {group.title}
          </h3>
        </div>
      </div>

      <div className="p-6 sm:p-8 flex flex-col flex-1">
        <p className="text-slate-600 leading-relaxed">{group.blurb}</p>

        <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 flex-1">
          {group.items.map((item) => (
            <li
              key={item.label}
              data-testid={`service-item-${group.id}-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex items-center gap-2.5 text-sm text-green-900"
            >
              <CheckCircle2 className="w-4 h-4 text-green-600 shrink-0" />
              <span>{item.label}</span>
            </li>
          ))}
        </ul>

        <a href="#contact" data-testid={`service-cta-${group.id}`} className="mt-7">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-green-700 hover:text-green-900 group/cta">
            Enquire about {group.title.toLowerCase()}
            <ArrowRight className="w-4 h-4 transition-transform group-hover/cta:translate-x-1" />
          </span>
        </a>
      </div>
    </article>
  );
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 sm:py-28 lg:py-32 bg-green-50/40 brand-glow"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span
            data-testid="services-eyebrow"
            className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest"
          >
            What we do
          </span>
          <h2
            data-testid="services-headline"
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-green-950 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Complete pond &amp; garden care.
          </h2>
          <p className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">
            From full pond cleans and relining to weeding, pruning and seasonal upkeep —
            one local team to keep your outdoor space looking its best.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <ServiceColumn group={POND_SERVICES} />
          <ServiceColumn group={GARDEN_SERVICES} />
        </div>
      </div>
    </section>
  );
};

export default Services;
